/* Share button component — Dawn-compatible */
if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.button = this.querySelector('button');
        this.urlToShare = this.querySelector('input')
          ? this.querySelector('input').value
          : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.button.classList.remove('hidden');
          this.button.addEventListener('click', this.shareLink.bind(this));
        } else {
          this.button.classList.add('hidden');
          this.addAccessibilityAttributes(this.mainDetailsToggle.querySelectorAll('[id]'));
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          const copyButton = this.querySelector('button.share-button__copy');
          if (copyButton) {
            copyButton.addEventListener('click', this.copyToClipboard.bind(this));
          }
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          const summaryElement = this.mainDetailsToggle.querySelector('summary');
          if (summaryElement) summaryElement.setAttribute('aria-expanded', false);
          this.querySelectorAll('.share-button__close, .share-button__copy').forEach((elt) =>
            elt.classList.add('hidden')
          );
        }
      }

      shareLink() {
        navigator
          .share({
            url: this.urlToShare,
            title: document.title,
          })
          .catch((err) => {
            console.error('Share failed:', err);
          });
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          const msg = this.querySelector('.share-button__message');
          if (msg) {
            msg.textContent = this.getAttribute('data-success-message') || 'Copied';
            msg.classList.remove('hidden');
            setTimeout(() => msg.classList.add('hidden'), 2000);
          }
        });
      }

      addAccessibilityAttributes(elements) {
        elements.forEach((element) => {
          element.setAttribute('aria-hidden', true);
        });
      }
    }
  );
}
